import Layout, { Header, Content, Footer } from './layout';
import Sidebar from './sidebar';
var DefaultLayout = Layout;
DefaultLayout.Sidebar = Sidebar;
DefaultLayout.Header = Header;
DefaultLayout.Content = Content;
DefaultLayout.Footer = Footer;
export default DefaultLayout;
//# sourceMappingURL=index.js.map